import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

import { EnhancedTableRowCell } from 'components/Table/EnhancedTableRow/styles';

// $inline drops the table-cell padding for callers that render into a layout of their own rather
// than a grid row.
export const Cell = styled(EnhancedTableRowCell)<{ $inline?: boolean }>`
  ${({ $inline }) => $inline && 'padding: 0;'}
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const TasksLabel = styled.p`
  // No global p reset exists, so without this the UA block margins make the row 22px taller.
  margin: 0;
  margin-left: 8px !important;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  letter-spacing: 0.17px;
  padding-bottom: 3px;
`;

export const StyledCircularProgress = styled(CircularProgress).attrs({
  variant: 'determinate',
  size: '16px',
  thickness: 5,
})`
  flex: 1;
`;
